import { MenubarItem } from "@/components/ui/menubar";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useProjectStoreContext } from "./ProjectStoreContext";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { useCheckIsProjectLocked } from "../hooks/useCheckIsProjectLocked";

const AssignStoresToProjectsMenubarItem = () => {
  const { t } = useTranslation();
  const { setIsAddLimitsDialogOpen } = useProjectStoreContext();
  const { can_update } = useModulePermissions();
  const isProjectLocked = useCheckIsProjectLocked();

  const onAddPeriods = useCallback(() => {
    setIsAddLimitsDialogOpen(true);
  }, [setIsAddLimitsDialogOpen]);

  return (
    <MenubarItem
      onClick={onAddPeriods}
      disabled={!can_update || isProjectLocked}
    >
      {t("projects.menubar.store.addLimits")}
    </MenubarItem>
  );
};

export default AssignStoresToProjectsMenubarItem;
